/**
 * Product card broken-image status probe (ISS-04-093)
 *
 * Server implementation is: GET /api/v1/products/image-status?url=...
 * Routed through our own backend (not the browser fetching the broken image
 * URL directly) because browsers refuse to expose a cross-origin response's
 * real status when the host doesn't send CORS headers — PHP isn't bound by
 * that restriction, so the probe has to happen server-side.
 */

import { ApiBase } from "../../../core/api-base";

interface ImageStatusResponseBody {
    success?: number;
    data?: {
        status?: string;
    };
}

class ProductCardImageErrorApiService extends ApiBase {
    public static async fetchStatusLabel(imageUrl: string): Promise<string> {
        try {
            const response = await super.apiGet(`/api/v1/products/image-status?url=${encodeURIComponent(imageUrl)}`, {
                noSpinner: true,
            });

            const body = (await response.json().catch(() => null)) as ImageStatusResponseBody | null;
            if (!response.ok || !body || body.success !== 1 || !body.data?.status) {
                return "ERR";
            }

            return body.data.status;
        } catch {
            return "ERR";
        }
    }
}

export { ProductCardImageErrorApiService };
